import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { useContent } from "hooks/discovery";
import Ellipsis from "components/Ellipsis";
import ItemsFoundTerm from "layout/discovery/document/ByContent/ItemsFoundTerm";
import { splitTerms } from "layout/discovery/helpers";

const BodyRow = ({
  item: { index, location, ref, text, items },
  maxFreq,
  columnWidths,
}) => {
  const [firstColumn, secondColumn] = useMemo(() => splitTerms(items), [items]);
  const content = useContent(text, false);

  const getTerms = (terms) => {
    return terms.map(({ freq, legend }) => (
      <ItemsFoundTerm
        key={legend}
        freq={freq}
        maxFreq={maxFreq}
        legend={legend}
      />
    ));
  };

  return (
    <div className="by_content__body__row" data-testid="by_content-body-row">
      <span
        style={{ width: columnWidths[0] }}
        className="by_content__body__row__index"
      >
        <Ellipsis text={index} />
      </span>
      <Ellipsis
        text={location}
        classes="by_content__body__row__location"
        style={{ width: columnWidths[1] }}
      />
      <Ellipsis
        text={ref}
        classes="by_content__body__row__ref"
        style={{ width: columnWidths[2] }}
      />
      <span
        style={{ width: columnWidths[3] }}
        className="by_content__body__row__content"
      >
        {content}
      </span>
      <span
        style={{ width: columnWidths[4] }}
        className="by_content__body__row__items_found"
      >
        <div className="by_content__body__row__items_found__column">
          {getTerms(firstColumn)}
        </div>
        <div className="by_content__body__row__items_found__column">
          {getTerms(secondColumn)}
        </div>
      </span>
    </div>
  );
};

BodyRow.propTypes = {
  item: PropTypes.shape({
    index: PropTypes.number.isRequired,
    location: PropTypes.string.isRequired,
    ref: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        freq: PropTypes.number.isRequired,
        legend: PropTypes.string.isRequired,
      })
    ).isRequired,
  }).isRequired,
  maxFreq: PropTypes.number.isRequired,
  columnWidths: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  ).isRequired,
};

export default BodyRow;
